export default "__VITE_ASSET__Cky5kCmV__"